/*Events js Helpers */

/**
 * Pass the url that needs GTM linker param.
 * If GoogleAnalyticsObject is available linker param will be appened to url passed
 * @param {String} url 
 * @returns {String}
 */
 const decorateUrl = (url) => {
  var _ga = window[window['GoogleAnalyticsObject']];

  if (_ga && url.indexOf('_ga') <= -1
    && typeof _ga.getAll === "function"
    && _ga.getAll().length
  ) {
    let hashIndex = url.indexOf('#');
    let linkerParam;
    if (url.indexOf("?") !== -1) {
      linkerParam = '&' + _ga.getAll()[0].get('linkerParam');
    } else {
      linkerParam = '?' + _ga.getAll()[0].get('linkerParam');
    }
    if (hashIndex !== -1) {
      return url.slice(0, hashIndex) + linkerParam + url.slice(hashIndex);
    } else {
      return url + linkerParam;
    }
  }
  return url;
}

export { decorateUrl }